import {
  UPDATE_PROJECT_SCHEDULE_CHANGE,
  UPDATE_PROJECT_SCHEDULE_CHANGE_DATE,
  UPDATE_PROJECT_SCHEDULE_CHANGE_DATE_INPUT,
  UPDATE_PROJECT_SCHEDULE_CHANGE_TOGGLE_ENABLED,
  RESET_PROJECT_SCHEDULE_CHANGE,
  disabledByDefault
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'
import { getMonthDayYear, getMonthDayFullYear } from 'helpers/DateUtil'
import { SPEC_ORDER } from 'containers/Project/Specifications/constants'

const getInitialProjectScheduleChange = () => {
  const scheduleTypes = SPEC_ORDER.schedule
  var initialObject = {}
  scheduleTypes.forEach((scheduleType) => {
    initialObject[scheduleType] = {
      date: '',
      dateInput: '',
      enabled: !disabledByDefault.includes(scheduleType)
    }
  })
  return initialObject
}

const getDateFromText = (text) => {
  return text.split('').reduce((result, value, index, array) => {
    if (index % 2 === 0 )
      result.push(array.slice(index, index + 2).join(''))
    return result
  }, []).join('/')
}

const updateProjectScheduleChange = (prevSchedule, { schedule }) => {
  const newSchedule = { ...schedule }
  Object.keys(newSchedule).forEach((key, index) => {
    newSchedule[key] = { 
      ...newSchedule[key], 
      dateInput: newSchedule[key].date ? getMonthDayYear(new Date(newSchedule[key].date)).replace(/\//g, '') : ''
    }
  })
  return newSchedule
}

const updateProjectScheduleChangeDate = (prevSchedule, { param, date }) => {
  const newSchedule = { ...prevSchedule }
  newSchedule[param].date = date.toString()
  newSchedule[param].dateInput = getMonthDayYear(new Date(newSchedule[param].date)).replace(/\//g, '')
  return newSchedule
}

const updateProjectScheduleChangeDateInput = (prevSchedule, { param, dateInput }) => {
  const newSchedule = { ...prevSchedule }
  newSchedule[param].date = ''
  const formattedInput = getDateFromText(dateInput)
  if(!isNaN(Date.parse(formattedInput)) && dateInput.length > 0){
    newSchedule[param].date = getMonthDayFullYear(new Date(formattedInput)) 
  }
  newSchedule[param].dateInput = dateInput
  return newSchedule
}

const updateProjectScheduleChangeToggleEnabled = (prevSchedule, { param }) => {
  const newSchedule = { ...prevSchedule }
  newSchedule[param].enabled = !newSchedule[param].enabled
  return newSchedule
}

const projectScheduleChangeReducer = createReducer(getInitialProjectScheduleChange(), {
  [RESET_PROJECT_SCHEDULE_CHANGE]: getInitialProjectScheduleChange,
  [UPDATE_PROJECT_SCHEDULE_CHANGE]: updateProjectScheduleChange,
  [UPDATE_PROJECT_SCHEDULE_CHANGE_DATE]: updateProjectScheduleChangeDate,
  [UPDATE_PROJECT_SCHEDULE_CHANGE_DATE_INPUT]: updateProjectScheduleChangeDateInput,
  [UPDATE_PROJECT_SCHEDULE_CHANGE_TOGGLE_ENABLED]: updateProjectScheduleChangeToggleEnabled
})


export default combineReducers({
  projectScheduleChange: projectScheduleChangeReducer
})
